import "./Home.module.css";
import CorporateHeader from "@/reusable_sections/Header";
import DigitalExcellenceForLifeSciences from "./sections/DigitalExcellenceForLifeSciences";
import OurStrategicDistributionServices from "./sections/OurStrategicDistributionServices";
import WhyChooseUs from "./sections/WhyChooseUs";
import ClientAlphaResults from "./sections/ClientAlphaResults";
import SecureYourConsultation from "./sections/SecureYourConsultation";
import GlobalFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <CorporateHeader />
      <DigitalExcellenceForLifeSciences />
      <OurStrategicDistributionServices />
      <WhyChooseUs />
      <ClientAlphaResults />
      <SecureYourConsultation />
      <GlobalFooter />
    </div>;
}